import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChangeStringValues } from "types/Auth";

import {
  REFERRAL_STEPS,
  ReferralItemType,
  ReferralListResponse,
  ReferralResponse,
  ReferralState,
  WithdrawalResponse,
} from "../../types/Referral";

const initialState: ReferralState = {
  invitationLink: "",
  referralList: [],
  total: 0,
  lastPage: 0,
  enabled: false,
  success: null,
  status: REFERRAL_STEPS.AMOUNT,
  amount: "",
  error: "",
};

export const referralSlice = createSlice({
  name: "referral",
  initialState,
  reducers: {
    changeStringField(state, action: PayloadAction<ChangeStringValues>) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    setLink(state, action: PayloadAction<ReferralResponse>) {
      state.invitationLink = action.payload.invitationLink;
    },
    setReferralList(state, action: PayloadAction<ReferralListResponse>) {
      // eslint-disable-next-line no-console
      console.log("setReferralList", action.payload);
      const { items, total } = action.payload;
      const existingIds = new Set(
        state.referralList.map((referral) => referral.referralId),
      );

      const uniqueItems = items.filter(
        (item) => !existingIds.has(item.referralId),
      );

      if (uniqueItems.length > 0) {
        state.referralList = [...state.referralList, ...uniqueItems];
      }
      // eslint-disable-next-line no-console
      console.log("state.referralList", state.referralList);
      state.total = total;
      state.lastPage = Math.ceil(total / 5);
    },

    updateReferral(state, action: PayloadAction<ReferralItemType>) {
      // eslint-disable-next-line no-console
      console.log("updateReferral", action.payload);
      const { referralId, profit } = action.payload;
      const index = state.referralList.findIndex(
        (item) => item.referralId === Number(referralId),
      );
      if (index !== -1) {
        state.referralList[index] = {
          ...state.referralList[index],
          profit,
        };
      }
    },

    deleteReferral(state, action: PayloadAction<number>) {
      state.referralList = state.referralList.filter(
        (referral) => referral.referralId !== action.payload,
      );
      state.total -= 1;
      state.lastPage = Math.ceil(state.total / 5);
      // eslint-disable-next-line no-console
      console.log("deleteReferral", action.payload);
    },
    addReferral(state, action: PayloadAction<ReferralItemType>) {
      const newReferral = { ...action.payload, profit: 0 };
      state.referralList.unshift(newReferral);
      state.total += 1;
      state.lastPage = Math.ceil(state.total / 5);
      // eslint-disable-next-line no-console
      console.log("addReferral", action.payload);
    },
    clear() {
      return { ...initialState };
    },
    setEnabled(state, action: PayloadAction<boolean>) {
      state.enabled = action.payload;
    },
    setSuccess(state) {
      state.status = REFERRAL_STEPS.SUCCESS;
    },
    setError(state, action: PayloadAction<WithdrawalResponse>) {
      state.error = action.payload.message;
      state.status = REFERRAL_STEPS.FAILED;
    },
    clearStatus(state) {
      state.error = "";
      state.amount = "";
      state.status = REFERRAL_STEPS.AMOUNT;
    },
    clearState(state) {
      return {
        ...state,
        success: null,
        status: REFERRAL_STEPS.AMOUNT,
        error: "",
        amount: "",
      };
    },
  },
});

export const {
  changeStringField,
  clear,
  setLink,
  setReferralList,
  updateReferral,
  deleteReferral,
  addReferral,
  setEnabled,
  setSuccess,
  setError,
  clearStatus,
  clearState,
} = referralSlice.actions;

export default referralSlice.reducer;
